import { Injectable } from "@angular/core";
import { MessagePromptModalComponent } from "@modules/modals/message-prompt-modal/message-prompt-modal.component";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { ErrorModel } from "src/app/shared/interfaces/exception";
import { ModalService } from "src/app/shared/services/modal.service";

import {
  PROMPT_ERROR,
  RESET_ERROR_MESSAGE,
  SET_ERROR_MESSAGE,
} from "./error.action";

@State<ErrorModel>({
  name: "ErrorState",
  defaults: {
    status: null,
    timestamp: null,
    detail: {
      error: null,
      message: null,
      info: null,
      isError: false,
    },
  },
})
@Injectable()
export class ErrorState {
  constructor(private readonly modalService: ModalService) {}

  @Selector()
  public static errorDetail(state: ErrorModel) {
    return state.detail;
  }

  @Selector()
  public static status(state: ErrorModel) {
    return state.detail.isError;
  }

  @Action(SET_ERROR_MESSAGE)
  public setErrorMessage(
    { patchState }: StateContext<ErrorModel>,
    { payload }: SET_ERROR_MESSAGE,
  ) {
    patchState({
      detail: {
        error:
          payload.error == null || payload.error === ""
            ? "Service Unavailable"
            : payload.error,
        message:
          payload.message == null || payload.message === ""
            ? "The service is temporarily unavailable. Please try again later."
            : payload.message,
        info: payload.info,
        isError: true,
      },
    });
  }

  @Action(PROMPT_ERROR)
  public promptError(
    { patchState }: StateContext<ErrorModel>,
    { payload }: PROMPT_ERROR,
  ) {
    patchState({
      detail: {
        error:
          payload.error == null || payload.error === ""
            ? "Service Unavailable"
            : payload.error,
        message:
          payload.message == null || payload.message === ""
            ? "The service is temporarily unavailable. Please try again later."
            : payload.message,
        info: payload.info,
        isError: false,
      },
    });
    this.modalService.openDialog(
      MessagePromptModalComponent,
      {
        data: {
          error: payload.error,
          message: payload.message,
        },
      },
      {
        panelClass: ["dialog-background", "message-prompt-modal-panel"],
      },
    );
  }

  @Action(RESET_ERROR_MESSAGE)
  public resetErrorMessage({ patchState }: StateContext<ErrorModel>) {
    patchState({
      detail: {
        error: null,
        message: null,
        info: null,
        isError: false,
      },
    });
  }
}
